import { render, staticRenderFns } from "./ios.vue?vue&type=template&id=5860be02&"
import script from "./ios.vue?vue&type=script&lang=js&"
export * from "./ios.vue?vue&type=script&lang=js&"
import style0 from "./ios.vue?vue&type=style&index=0&id=5860be02&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports